import React, { ReactNode } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-duotone-svg-icons';

interface Props {
  title: string;
  icon: IconProp;
  children: ReactNode;
  isOpen: boolean;
  toggle: () => void;
}

const SidebarSection: React.FC<Props> = ({ title, icon, children, isOpen, toggle }) => {
  return (
    <>
      <h2 className="flex cursor-pointer items-center justify-between" onClick={toggle}>
        <div className="flex items-center text-sm font-medium hover:underline">
          <FontAwesomeIcon icon={icon} className="mr-2" />
          {title}
        </div>
        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} className="text-[#A1A6B7]" />
      </h2>
      {isOpen && <div>{children}</div>}
    </>
  );
};

export default SidebarSection;
